import { render, staticRenderFns } from "./CourseStudents.vue?vue&type=template&id=31c94307"
import script from "./CourseStudents.vue?vue&type=script&lang=js"
export * from "./CourseStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports